module.exports = __webpack_public_path__ + "img/cup.e7237279.svg";